'use client';

import { type PropsWithChildren, type RefObject, useRef } from 'react';
import { useResizeObserver } from 'usehooks-ts';

interface Props extends PropsWithChildren {
  id: string;
}

const SlicePreviewWrapper: React.FC<Props> = ({ id, children }) => {
  const ref = useRef<HTMLDivElement>(null);

  useResizeObserver({
    ref: ref as RefObject<HTMLDivElement>,
    onResize(size) {
      parent.postMessage(
        {
          type: 'slice-machine-previewer:set-height',
          id,
          height: Math.max(120, size.height || 0),
        },
        '*'
      );
    },
  });

  return (
    <div
      className="relative isolate flex flex-col"
      data-slice-preview-id={id}
      ref={ref}
    >
      {children}
    </div>
  );
};

export default SlicePreviewWrapper;
